import { useEffect, useRef, useState } from "react";
import MenuIconImg from "../../img/menu.png";

import {
  CloseIcon,
  Container,
  ContainerHeader,
  LogoWrapper,
  MenuContent,
  MenuIcon,
  MenuOverlay,
  MenuDesktop,
} from "./HeaderStyles";

import { Link, useLocation, useNavigate } from "react-router-dom";
import LogoAnimated from "../logoAnimated/LogoAnimated";

export function Header() {
  const [open, setOpen] = useState(false);
  const [isDesktop, setIsDesktop] = useState(window.innerWidth > 1024);

  const location = useLocation();
  const navigate = useNavigate();
  const menuRef = useRef<HTMLDivElement>(null);

  const handleNavigateToSection = (id: string) => {
    setOpen(false);

    if (location.pathname !== "/") {
      navigate(`/#${id}`);
    } else {
      const section = document.getElementById(id);
      if (section) {
        section.scrollIntoView({ behavior: "smooth" });
      }
    }
  };

  // Detecta clique fora do menu
  useEffect(() => {
    function handleClickOutside(event: MouseEvent) {
      if (menuRef.current && !menuRef.current.contains(event.target as Node)) {
        setOpen(false);
      }
    }

    if (open) {
      document.addEventListener("mousedown", handleClickOutside);
    } else {
      document.removeEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [open]);

  useEffect(() => {
    const handleResize = () => {
      setIsDesktop(window.innerWidth > 1024);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <Container>
      <ContainerHeader>
        <LogoWrapper>
          <LogoAnimated />
        </LogoWrapper>

        {isDesktop ? (
          <MenuDesktop>
            <a href="/">Início</a>
            <Link to="/" onClick={() => handleNavigateToSection("why")}>
              Por que usar?
            </Link>
            <Link to="/" onClick={() => handleNavigateToSection("how")}>
              Como funciona?
            </Link>
            <Link to="/login" onClick={() => setOpen(false)}>
              <strong>Login</strong>
            </Link>
            <Link to="/register" onClick={() => setOpen(false)}>
              Cadastrar
            </Link>
          </MenuDesktop>
        ) : (
          <MenuIcon onClick={() => setOpen(true)}>
            <img src={MenuIconImg} alt="Menu" />
          </MenuIcon>
        )}
      </ContainerHeader>

      {!isDesktop && open && (
        <MenuOverlay>
          <div ref={menuRef}>
            <CloseIcon onClick={() => setOpen(false)}>×</CloseIcon>

            <div style={{ marginBottom: "3rem" }}>
              <LogoAnimated />
            </div>

            <MenuContent>
              <a href="/">Início</a>
              <Link to="/" onClick={() => handleNavigateToSection("why")}>
                Por que usar o Press Kit?
              </Link>
              <Link to="/" onClick={() => handleNavigateToSection("how")}>
                Como funciona?
              </Link>
              <Link to="/login" onClick={() => setOpen(false)}>
                Login
              </Link>
              <Link to="/register" onClick={() => setOpen(false)}>
                Cadastrar
              </Link>
            </MenuContent>
          </div>
        </MenuOverlay>
      )}
    </Container>
  );
}
